(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:LocalPhases
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('LocalPhases', LocalPhases);

  function LocalPhases($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/ajuntaments/:id/phases', {id: '@_id'});
  }
}());
